'use client';
import clsx from 'clsx';
import { ComponentProps, FC } from 'react';

import { CTAButton } from 'src/general/components/Button/CTAButton';
import { Image } from 'src/general/components/Image/Image';
import { pushToDataLayer } from 'src/utils/pushToDataLayer';

type Props = Partial<{
  title: string;
  description?: string;
  image: string;
  cta: ComponentProps<typeof CTAButton>[];
  plpMarketingTileClickEvent: object;
}> & { variant: 'plp' | 'carousel' };

export const PlpMarketingTile: FC<Props> = ({
  title,
  description,
  image,
  cta,
  variant,
  plpMarketingTileClickEvent,
}) => {
  const hasImage = !!image;
  const hasDescription = !!description;
  const hasCta = !!cta?.length;

  const trackMarketingTileClickEvent = () => {
    if (plpMarketingTileClickEvent) {
      pushToDataLayer(plpMarketingTileClickEvent);
    }
  };

  return (
    <div
      data-testid={variant === 'carousel' ? 'recently-viewed-marketing-tile' : 'marketing-title-recently-viewed'}
      className={clsx('PlpMarketingTile', {
        ['PlpMarketingTile-noCta']: !hasCta,
        ['PlpMarketingTile-carouselTile']: variant === 'carousel',
      })}
    >
      <div className="PlpMarketingTile-imageContainer">
        <div className={'PlpMarketingTile-imageWrapper'}>
          {hasImage && <Image src={image} alt="" width={100} height={100} className="PlpMarketingTile-image" />}
        </div>
      </div>
      <div className="PlpMarketingTile-contentContainer">
        <div className={clsx('c-fs-h5', 'font-extrabold')}>{title}</div>
        {hasDescription && <div className={clsx('PlpMarketingTile-description', 'c-fs-body2')}>{description}</div>}
      </div>
      {hasCta && (
        <div
          className={clsx('PlpMarketingTile-ctaContainer', {
            ['PlpMarketingTile-carouselSpacing']: variant === 'carousel',
          })}
        >
          <CTAButton
            {...cta[0]}
            size="small"
            fullWidth
            onClick={(e: React.MouseEvent<HTMLAnchorElement> & React.MouseEvent<HTMLButtonElement>) => {
              if (cta[0].onClick) {
                cta[0].onClick(e);
              }
              trackMarketingTileClickEvent();
            }}
          />
        </div>
      )}
    </div>
  );
};
